<template>
  <div id="tips" class="mt-4">
    <div class="container">
      <div class="row text-center">
        <div class="col-12 text-center pt-4">
          <h2>Tips de compra</h2>
          <p>Descubre como participar y conseguir los productos Samsung al mejor precio</p>
        </div>
      </div>
    </div>
    <div class="container tips">
      <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true">
        <!--tip-->
        <div class="row tip align-items-center">
          <div class="col-6 text-center">
            <img src="../assets/img/tips/icon-01.png" class="ico" />
          </div>
          <div class="col-6">
            <h4>Tip 1</h4>
            <p>
              Mantente atento, ya que durante el LiveShop, se mostrarán en pantalla las ofertas.
            </p>
          </div>
        </div>
        <!--tip-->
        <div class="row tip align-items-center">
          <div class="col-6 text-center">
            <img src="../assets/img/tips/icon-02.png" class="ico" />
          </div>
          <div class="col-6">
            <h4>Tip 2</h4>
            <p>
              Para comprar, solo debes tocar (o seleccionar) la oferta y luego seleccionar el modelo que más te guste
            </p>
          </div>
        </div>
        <!--tip-->
        <div class="row tip align-items-center">
          <div class="col-6 text-center">
            <img src="../assets/img/tips/icon-03.png" class="ico" />
          </div>
          <div class="col-6">
            <h4>Tip 3</h4>
            <p>
              Cuando elijas tu próximo producto, se agregará inmediatamente a tu carro de compras
            </p>
          </div>
        </div>
        <!--tip
        <div class="row tip align-items-center">
          <div class="col-6 text-center">
            <img src="../assets/img/tips/icon-04.png" class="ico" />
          </div>
          <div class="col-6">
            <h4>Tip 4</h4>
            <p>
              ¡Y muy importante! Antes de comprar, no olvides ingresar el código correspondiente a la oferta en el checkout
            </p>
          </div>
        </div>-->
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Tips",
  components: { VueSlickCarousel },
};
</script>

<style lang="scss">
#app{
  background-color: white !important;
}
#tips{
  .slick-prev:before, .slick-next:before{
    color: black;
  }
  .slick-next{
    right: -10px;
  }
  .slick-prev{
    left: -10px;
  }
}
.tips {

  h2 {
    font-weight: 700;
  }
  .slick-dots {
    bottom: 5px;
  }
}
.tip {
  display: flex !important;
  font-size: 14px;
  padding: 15px 0 40px 0;
  h4 {
    font-weight: 700;
  }
  img.ico {
    width: 80%;
    height: auto;
    margin: 0 auto;
  }
}
.slick-dots li button:before {
  font-size: 14px !important;
}
@media only screen and (max-width: 480px) {
  .tip {
    img.ico {
      width: 90%;
    }
  }
}
</style>